import variables from '@/styles/variables.scss'

const mixin = {
  data () {
    return {
      pagination: {
        total: 0,
        currentPage: 1,
        size: 10,
        currentChange: (page) => {
          this.handleCurrentChange(page)
        },
        sizeChange: (size) => {
          this.handleSizeChange(size)
        }
      },
      isShowPage: false,
      rowData: null,
      isAdmin: sessionStorage.username === 'admin'  // 登录者是否是管理员
    }
  },
  computed: {
    variables () {
      return variables
    },
    fontsize () {
      return {
        fontSize: '14px'
      }
    }
  },
  methods: {
    resetList () {
      this.pagination.currentPage = 1
      this.clearParams()
    },
    handleSizeChange (val) {
      this.pagination.size = val
      this.pagination.currentPage = 1
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    },
    handleClose () {
      this.cancel()
    },
    // 批量删除
    delTableMulti () {
      if (!this.deletIds.length) {
        this.$message.warning('请选择删除项')
        return
      }
      this.deleteItem(this.deletIds)
    }
  }
}

export default mixin
